const CREDITABLE_LANE_PATTERNS = [
  'rental_fee',
  'extra:',
  'custom_extra:',
  'additional_costs:',
  'cancellation_fee:',
] as const;

/** Manual lane credit — booking lanes plus cancellation/rebooking fees (invoice-owned / custom use full cancel). */
export function isManualLaneCreditable(lane: string): boolean {
  return CREDITABLE_LANE_PATTERNS.some((pattern) => lane.startsWith(pattern));
}
